export enum RebookersEndpoints {
    GetIsValidRebooker = '/v1/rebookers/is-valid?roomCode={roomCode}',
    GetRebookerActive = '/v1/rebookers/rebooker-active?roomCode={roomCode}',
}
